import React, { useCallback, useContext, useEffect, useState } from "react";
import { errorSchema, utils } from "helper";
import {
  CommonInput,
  CommonModal,
  CommonTextarea,
  CustomSelect,
} from "components";
import StorageService from "utils/StorageServices/StorageServices";
import toast, { Toaster } from "react-hot-toast";
import { StorageServices } from "utils";
import SingleSelectDropdownInfinite from "components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite";
import AddEditVehicleModal from "modals/AddEditVehicleModal";
import AddEditSupplier from "modals/AddEditSupplier";
import AddEditOwnDriver from "modals/AddEditOwnDriver";

const formObj = {
  company_id: StorageService.getCompanyId(),
  name: "",
  // fastag_company_id: "",
};

const AddEditModal = (props) => {
  const {
    isOpen,
    closeModal,
    nextModal,
    placeholder,
    label,
    ApiPoint,
    callBackApi,
    titleName = "",
    payloadData = {},
    isLabelData,
    fuelCardCompanyList = [],
    fastagCompanyList = [],
    branchList = [],
    fetchUsers = () => { }
  } = props;
  const [formValue, setFormValue] = useState(formObj);
  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showOffcanvasOfSupplier, setShowOffcanvasOfSupplier] = useState(false);
  const [showOffcanvasOfDriver, setShowOffcanvasOfDriver] = useState(false);
  const [isSupplier, setIsSupplier] = useState(false);
  const [isDriver, setIsDriver] = useState(false);

  console.log(isOpen)
  const handleOnChange = async (name, value) => {
    const stateObj = { ...formValue, [name]: value };
    setFormValue(stateObj);
    const schemaPayload = {
      1: errorSchema.addExpenseCategorySchema,
      2: errorSchema.addFastagMasterSchema,
      3: errorSchema.addFuelCardCompanySchema,
      5: errorSchema.planBranchUpdateSchema,
      6: errorSchema.planVehicleUpdateSchema
    };
    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.checkFormError(
        stateObj,
        schemaPayload[titleName == "Trip" ? 1 : titleName == "fuel_card" ? 3 : titleName == "branch" ? 5 : titleName == "Vehicle" ? 6 : 2]
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const apiCallingFunction = async () => {

    const customePayload = {
      1: {
        company_id: formValue?.company_id,
        name: formValue?.name
      },

      2: {
        company_id: StorageServices?.getCompanyId(),
        category_id: payloadData?.category_id,
        sub_category_id: payloadData?.sub_category_id,
        name: formValue?.name
      },
      3: {
        company_id: formValue?.company_id,
        account_number: formValue?.name,
        fuelcard_company_id: formValue?.fuelcard_company_id,
      },
      4: {
        company_id: formValue?.company_id,
        customer_id: formValue?.name,
        fastag_company_id: formValue?.fastag_company_id
      },
      5: {
        company_id: StorageServices?.getCompanyId(),
        plan_id: isOpen?._id,
        branch_id: formValue?.branch_id?._id || "",
        vehicle_id: formValue?.vehicle_id?._id || "",
        lorry_type_id: "",
        vehicle_type_id: "",
        responses: "",
      },
      6: {
        company_id: StorageServices?.getCompanyId(),
        plan_id: isOpen?._id,
        branch_id: '',
        vehicle_id: formValue?.vehicle_id?._id || "",
        lorry_type_id: "",
        vehicle_type_id: "",
        responses: "",
      }
    };

    try {
      const res = await ApiPoint(
        customePayload[
        titleName == "Trip"
          ? 2
          : titleName == "fuel_card"
            ? 3
            : titleName == "fastag"
              ? 4
              : titleName == "branch"
                ? 5 : titleName == "Vehicle" ? 6 : 1
        ]
      );
      if (res.responseCode === 200) {
        setFormValue({});
        setLoading(false);
        toast.success(res?.responseMessage);
        closeModal(false);
        callBackApi(res?.data);
      } else {
        setLoading(false);
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const handleClick = async (value) => {

    const schemaPayload = {
      1: errorSchema.addExpenseCategorySchema,
      2: errorSchema.addFastagMasterSchema,
      3: errorSchema.addFuelCardCompanySchema,
      5: errorSchema.planBranchUpdateSchema,
      6: errorSchema.planVehicleUpdateSchema
    };
    const validationResult = await utils?.checkFormError(
      formValue,
      schemaPayload[titleName == "Trip" ? 1 : titleName == "fuel_card" ? 3 : titleName == "branch" ? 5 : titleName == "Vehicle" ? 6 : 2]
    );


    if (utils?.isObjectKeyEmpty(validationResult)) {
      setLoading(true);
      apiCallingFunction();
      setFormError("");
    } else {
      setFormError(validationResult);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setFormValue((s) => ({
        ...s,
        company_id: StorageService.getCompanyId(),
      }));
    }
  }, [isOpen]);

  const newCleanUpfunction = () => {
    setFormValue({});
    setFormError('');
    closeModal();
  }

  let inhanceProps = {
    ...props,
    closeModal: newCleanUpfunction,
    submitTitle: loading ? "Loading..." : props.submitTitle,
    disabled: loading,
    onSubmit: handleClick,
  };


  const handleAddNewSupplierButtonAction = () => {
    setIsSupplier(false);
    setShowOffcanvasOfSupplier(true);
  };

  const handleAddNewVehicleButtonAction = (data) => {
    setIsDriver(false);
    setShowOffcanvasOfDriver(true);
  };

  const handleSupplierNextModal = () => {
    setIsSupplier(!isSupplier);
    setShowOffcanvas(true);
  };

  const handleDriverNextModal = () => {
    setIsDriver(!isDriver);
    setShowOffcanvas(true);
  };

  const callBackVehicle = (data) => {
    console.log(data)

    const object = {
      ...data,
      name: data?.vehicle_no,
      label: data?.vehicle_no,
      value: data?._id
    }

    setFormValue((f) => ({ ...f, vehicle_id: object }))
    fetchUsers()
  }


  return (
    <div>
      <CommonModal {...inhanceProps}>
        <div className="addItem_body mt-2">
          <div className="colFlx">
            {!['branch', 'Vehicle'].includes(titleName) && (
              <div className="singleDiv">
                <CommonInput
                  type="text"
                  label={label}
                  placeholder={placeholder}
                  name="name"
                  value={formValue.name}
                  focus={!!(typeof formError === "object" && formError?.name)}
                  error={typeof formError === "object" ? formError?.name : ""}

                  maxLength={20}
                  onChange={(e) => utils.handleNameWithoutNumberChange(e, handleOnChange)}
                />
              </div>
            )}
            {titleName === 'fuel_card' && (
              <div className="singleDiv">
                <CustomSelect
                  options={fuelCardCompanyList}
                  label={isLabelData}
                  placeholder={isLabelData}

                  name="fuelcard_company_id"
                  focus={!!formError?.fuelcard_company_id}
                  error={formError.fuelcard_company_id}
                  onSelect={(data) =>
                    handleOnChange("fuelcard_company_id", data?.value)
                  }
                  value={fuelCardCompanyList.find((i) => i?.value == formValue?.fuelcard_company_id)}
                />
              </div>
            )}

            {titleName === 'fastag' && (
              <CustomSelect
                options={fastagCompanyList || []}
                label={isLabelData}
                placeholder={isLabelData}

                name="fastag_company_id"
                focus={!!formError?.fastag_company_id}
                error={formError.fastag_company_id}
                onSelect={(data) =>
                  handleOnChange("fastag_company_id", data?.value)
                }
                value={fastagCompanyList?.find((i) => i?.value == formValue?.fastag_company_id)}
              />
            )}


            {
              titleName === 'branch' && (
                <div className="singleDiv">
                  {/* <CustomSelect
                    options={branchList.filter((i) => i?.value != "")}
                    label={isLabelData}
                    placeholder={placeholder}
               
                    name="branch_id"
                    focus={!!formError?.branch_id}
                    error={formError.branch_id}
                    onSelect={(data) =>
                      handleOnChange("branch_id", data?.value)
                    }
                    value={branchList.find((i) => i?.value == formValue?.branch_id)}
                  /> */}
                  <SingleSelectDropdownInfinite
                    label="Branch"
                    fetchData={fetchUsers}
                    selectedItem={formValue?.branch_id}
                    onChange={(data) => {
                      handleOnChange("branch_id", data)
                    }}
                    error={!!formError["branch_id._id"]}
                    errorMessage={formError["branch_id._id"]}
                  />
                </div>
              )}

            {
              titleName === 'Vehicle' && (
                <div className="singleDiv">

                  <SingleSelectDropdownInfinite
                    label="Vehicle"
                    fetchData={fetchUsers}
                    selectedItem={formValue?.vehicle_id}
                    onChange={(data) => {
                      handleOnChange("vehicle_id", data)
                    }}
                    error={!!formError["vehicle_id._id"]}
                    errorMessage={formError["vehicle_id._id"]}
                    isAddButton={true}
                    addButtonAction={() => { setShowOffcanvas(true) }}
                  />

                </div>
              )}
          </div>
        </div>

        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
        >
          {showOffcanvas && (
            <AddEditVehicleModal
              isOpen={showOffcanvas}
              onClose={() => setShowOffcanvas(false)}
              callBackVehicle={callBackVehicle}
              isSupplier={isSupplier}
              isDriver={isDriver}
              handleAddNewSupplierButtonAction={
                handleAddNewSupplierButtonAction
              }
              handleAddNewVehicleButtonAction={
                handleAddNewVehicleButtonAction
              }
              hideAddNewOption={false}
              branchFirmId={isOpen?.firm_id}
              titleText="trip"

            />
          )}
        </div>

        <div className={showOffcanvas ? "offBack_drop" : ""}></div>

        {/* Supplier Canvas Open and Vahicle canvas will close */}
        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfSupplier ? "show" : ""
            }`}
          tabIndex={-1}
          style={{
            visibility: showOffcanvasOfSupplier ? "visible" : "hidden",
          }}
        >
          {showOffcanvasOfSupplier && (
            <AddEditSupplier
              isOpen={showOffcanvasOfSupplier}
              onClose={(e) => setShowOffcanvasOfSupplier(false)}
              callBackSupplier={(e) => handleSupplierNextModal(e)}
              hideAddNewOption={false}
              branchFirmId={isOpen?.firm_id}
            />
          )}
        </div>
        <div className={showOffcanvasOfSupplier ? "offBack_drop" : ""}></div>

        {/* Driver Canvas Open and Vahicle canvas will close */}
        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfDriver ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showOffcanvasOfDriver ? "visible" : "hidden" }}
        >
          {showOffcanvasOfDriver && (
            <AddEditOwnDriver
              isOpen={showOffcanvasOfDriver}
              onClose={() => setShowOffcanvasOfDriver(false)}
              callBackDriver={(e) => handleDriverNextModal(e)}
              hideAddNewOption={false}
              vehicleFirmId={isOpen?.firm_id}
            />
          )}
        </div>
        <div className={showOffcanvasOfDriver ? "offBack_drop" : ""}></div>


      </CommonModal>
      {/* <div className='offBack_drop'></div> */}
    </div>
  );
};

export default React.memo(AddEditModal);
